var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('inner-table',{ref:"dormitoryList",attrs:{"id":"innerDormitory","listviewurl":'xsgl.clazzDivideLog.list',"exclude-fields":"","can-edit":0,"can-delete":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }